import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/icon_sucess.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-3051ef31")

_pushScopeId("data-v-3051ef31")
const _hoisted_1 = { class: "dt-open-api-register" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "dt-open-api-register-title" }, "注册/Register", -1)
const _hoisted_3 = { class: "dt-open-api-register-border-box" }
const _hoisted_4 = { class: "dt-open-api-register-container" }
const _hoisted_5 = { class: "dt-open-api-register-content" }
const _hoisted_6 = { class: "dt-open-api-register-form" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { id: "captcha-button" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { id: "captcha-element" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode("点击注册")
const _hoisted_10 = { class: "dt-open-api-register-right-sec" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("已有账号 ")
const _hoisted_12 = /*#__PURE__*/_createVNode("a", { class: "click-element" }, "立即登录>>", -1)
const _hoisted_13 = { class: "dt-open-api-register-upload-sec" }
const _hoisted_14 = { class: "dt-open-api-register-upload-cover" }
const _hoisted_15 = {
  key: 1,
  class: "dt-open-api-register-upload-default"
}
const _hoisted_16 = /*#__PURE__*/_createVNode("p", { class: "dt-open-api-register-upload-info" }, "文件支持jpg、jpeg、bmp、png格式图片，大小不超过5MB", -1)
const _hoisted_17 = {
  key: 1,
  class: "dt-open-api-register-succes-content"
}
const _hoisted_18 = /*#__PURE__*/_createVNode("div", { class: "dt-open-api-register-succes-content-icon" }, [
  /*#__PURE__*/_createVNode("img", { src: _imports_0 })
], -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("p", { class: "dt-open-api-register-succes-content-text" }, "注册成功", -1)
const _hoisted_20 = /*#__PURE__*/_createTextVNode("返回首页")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("立即登录")
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_link = _resolveComponent("el-link")
  const _component_login_modal = _resolveComponent("login-modal")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            (_ctx.stepNum === 1)
              ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                  _createVNode("div", _hoisted_6, [
                    _createVNode(_component_el_form, {
                      ref: "formItemRef",
                      model: _ctx.formItem,
                      rules: _ctx.rules,
                      "label-width": "130px"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_form_item, {
                          label: "公司名称",
                          prop: "enterpriseFullName"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.formItem.enterpriseFullName,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (_ctx.formItem.enterpriseFullName = $event)),
                              modelModifiers: { trim: true },
                              placeholder: "请输入公司名称"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          label: "公司简称",
                          prop: "enterpriseShortName"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.formItem.enterpriseShortName,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (_ctx.formItem.enterpriseShortName = $event)),
                              modelModifiers: { trim: true },
                              placeholder: "请输入公司简称"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          label: "手机号码",
                          prop: "mobile"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.formItem.mobile,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (_ctx.formItem.mobile = $event)),
                              modelModifiers: { trim: true },
                              placeholder: "请输入手机号码"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          label: "验证码",
                          prop: "validateCode"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.formItem.validateCode,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => (_ctx.formItem.validateCode = $event)),
                              modelModifiers: { trim: true },
                              onBlur: _ctx.checkValidateCode,
                              placeholder: "请输入验证码"
                            }, {
                              suffix: _withId(() => [
                                _createVNode(_component_el_button, {
                                  type: "primary",
                                  onClick: _ctx.showCaptcha,
                                  round: "",
                                  disabled: _ctx.reSendTime != 120 && _ctx.reSendTime != 0
                                }, {
                                  default: _withId(() => [
                                    _createTextVNode(_toDisplayString(_ctx.reSendTime==120||_ctx.reSendTime==0?'获取验证码':'重新获取（'+_ctx.reSendTime+'）'), 1 /* TEXT */)
                                  ]),
                                  _: 1
                                }, 8, ["onClick", "disabled"]),
                                _hoisted_7,
                                _hoisted_8
                              ]),
                              _: 1
                            }, 8, ["modelValue", "onBlur"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          label: "统一社会信用码",
                          prop: "unifiedSocialCreditCode"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.formItem.unifiedSocialCreditCode,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => (_ctx.formItem.unifiedSocialCreditCode = $event)),
                              modelModifiers: { trim: true },
                              placeholder: "请输入18位字母、数字，字母区分大小写"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          label: "地区",
                          class: "dt-open-api-register-area-row",
                          prop: "provinceId",
                          rules: [{ required: true, message: '请选择地区'}]
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_select, {
                              modelValue: _ctx.provinceId,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => (_ctx.provinceId = $event)),
                              onChange: _cache[7] || (_cache[7] = $event => (_ctx.onProvinceChange($event,1))),
                              placeholder: "省",
                              "no-data-text": "暂无数据"
                            }, {
                              default: _withId(() => [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.provinces, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.id,
                                    label: item.areaName,
                                    value: item.id
                                  }, null, 8, ["label", "value"]))
                                }), 128 /* KEYED_FRAGMENT */))
                              ]),
                              _: 1
                            }, 8, ["modelValue"]),
                            _createVNode(_component_el_select, {
                              modelValue: _ctx.cityId,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => (_ctx.cityId = $event)),
                              onChange: _cache[9] || (_cache[9] = $event => (_ctx.onProvinceChange($event,2))),
                              placeholder: "市",
                              "no-data-text": "暂无数据"
                            }, {
                              default: _withId(() => [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.citys, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.id,
                                    label: item.areaName,
                                    value: item.id
                                  }, null, 8, ["label", "value"]))
                                }), 128 /* KEYED_FRAGMENT */))
                              ]),
                              _: 1
                            }, 8, ["modelValue"]),
                            _createVNode(_component_el_select, {
                              modelValue: _ctx.districtId,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => (_ctx.districtId = $event)),
                              onChange: _cache[11] || (_cache[11] = $event => (_ctx.onProvinceChange($event,3))),
                              placeholder: "区",
                              "no-data-text": "暂无数据"
                            }, {
                              default: _withId(() => [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.districts, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.id,
                                    label: item.areaName,
                                    value: item.id
                                  }, null, 8, ["label", "value"]))
                                }), 128 /* KEYED_FRAGMENT */))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          label: "密码",
                          prop: "password"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.formItem.password,
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => (_ctx.formItem.password = $event)),
                              modelModifiers: { trim: true },
                              "show-password": "",
                              placeholder: "请输入密码"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          label: "确认密码",
                          prop: "rePassword"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.formItem.rePassword,
                              "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => (_ctx.formItem.rePassword = $event)),
                              modelModifiers: { trim: true },
                              "show-password": "",
                              placeholder: "再次输入密码"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { style: {"float":"right"} }, {
                          default: _withId(() => [
                            _createVNode(_component_el_button, {
                              type: "primary",
                              onClick: _cache[14] || (_cache[14] = $event => (_ctx.registerFactory())),
                              round: ""
                            }, {
                              default: _withId(() => [
                                _hoisted_9
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["model", "rules"])
                  ]),
                  _createVNode("div", _hoisted_10, [
                    _createVNode("div", {
                      class: "dt-open-api-register-link",
                      onClick: _cache[15] || (_cache[15] = (...args) => (_ctx.gotoLogin(...args)))
                    }, [
                      _hoisted_11,
                      _hoisted_12
                    ]),
                    _createVNode("div", _hoisted_13, [
                      _createVNode("input", {
                        type: "file",
                        id: "uploadImage",
                        ref: "fileInput",
                        onChange: _cache[16] || (_cache[16] = (...args) => (_ctx.toUpload(...args))),
                        class: "dt-open-api-upload-input",
                        accept: "image/*"
                      }, null, 544),
                      _createVNode("div", _hoisted_14, [
                        (_ctx.formItem.businessLicense)
                          ? (_openBlock(), _createBlock("img", {
                              key: 0,
                              src: _ctx.formItem.businessLicense
                            }, null, 8, ["src"]))
                          : (_openBlock(), _createBlock("div", _hoisted_15))
                      ]),
                      _createVNode("div", {
                        class: "dt-open-api-register-upload-btn click-element",
                        onClick: _cache[17] || (_cache[17] = (...args) => (_ctx.uploadFileClick(...args)))
                      }, "上传营业执照"),
                      _hoisted_16
                    ])
                  ])
                ], 64 /* STABLE_FRAGMENT */))
              : _createCommentVNode("", true),
            (_ctx.stepNum === 2)
              ? (_openBlock(), _createBlock("div", _hoisted_17, [
                  _hoisted_18,
                  _hoisted_19,
                  _createVNode("div", null, [
                    _createVNode(_component_el_link, {
                      type: "primary",
                      style: {"margin-right":"20px"},
                      underline: _ctx.showUnderline,
                      href: "javascript:void(0);",
                      onClick: _ctx.gotoHomePage
                    }, {
                      default: _withId(() => [
                        _hoisted_20
                      ]),
                      _: 1
                    }, 8, ["underline", "onClick"]),
                    _createVNode(_component_el_link, {
                      type: "primary",
                      underline: _ctx.showUnderline,
                      href: "javascript:void(0);",
                      onClick: _ctx.gotoLogin
                    }, {
                      default: _withId(() => [
                        _hoisted_21
                      ]),
                      _: 1
                    }, 8, ["underline", "onClick"])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createVNode(_component_login_modal, {
      dialogVisible: _ctx.visibleModal,
      onCloseModal: _ctx.closeModal
    }, null, 8, ["dialogVisible", "onCloseModal"])
  ], 64 /* STABLE_FRAGMENT */))
})